import { SessionsKeys } from 'src/Common/constants';
import {
  getAddressObject,
  getProvinceList,
  getBankArray
} from '../Services/Services';

import VodacomLogo from 'src/Common/Images/saleslead_vodacom.png';

const CMS_Base_Url = `https://content${getEnv()}.vodacom.co.za/content/fibre/provider/images/`;
const _VUMATEL_LOGO = `https://content${getEnv()}.vodacom.co.za/content/fibre/provider/images/isp_vuma_reach_logo.png`;

const showProviderLogos = false;

export function getEnv() {
  let envObj = {
    'wwwdev.vodacom.co.za': 'dev',
    'wwwstg.vodacom.co.za': 'stg',
    'wwwqa.vodacom.co.za': 'qa',
    'www.vodacom.co.za': '',
    'localhost': 'qa'
  }
  let hostname = window.location.hostname;
  return (envObj[hostname])
}

export const addBeforeloadEvent = () => {
  window.onbeforeunload = onUnload;
}

export const removeBeforeloadEvent = () => {
  window.onbeforeunload = null;
}

const onUnload = (_event) => {
  return 'Confirm page reload';
}

export const checkInputValidity = (value, validations) => {
  //for boolean values
  if (typeof value === 'boolean') {
    return value;
  }

  //for string values
  let isValid = true;
  const trimmedVal = value && value.trim();

  if (validations?.required) {
    isValid = trimmedVal === '' ? false : true;
  }

  if (validations?.type === 'number') {
    isValid = trimmedVal.match(/^[0-9]+$/) === null ? false : true;
  }

  if (validations?.type === 'email') {
    isValid = validateEmail(trimmedVal);
  }

  if (validations?.minLength) {
    isValid = trimmedVal.length >= validations.minLength && isValid ? true : false;
  }

  if (validations?.maxLength) {
    isValid = trimmedVal.length <= validations.maxLength && isValid ? true : false;
  }

  if (validations?.isPhoneNumber) {
    isValid = /^\d{10}$/.test(trimmedVal) && isValid ? true : false;
  }

  if (validations?.selectOptions) {
    isValid = trimmedVal !== '--select--';
  }

  if (validations?.type === 'cellphoneNo') {
    isValid = validateCellphonNo(trimmedVal);
  }

  if (validations?.type === 'workNo') {
    isValid = validateWorkNo(trimmedVal);
  }

  if (validations?.type === 'idNumber') {
    isValid = validateIdNumber(trimmedVal);
  }

  if (validations?.type === 'salesOrderNumber') {
    isValid = validateSalesOrderNumber(trimmedVal);
  }

  if (validations?.specialText) {

    const specialTextValid = /^[A-Za-z\s'-]+$/.test(trimmedVal);

    if (!specialTextValid) {
      validations.invalidMessage = 'No special characters allowed';
    } else if (trimmedVal.length < 2 || trimmedVal.length > 50) {
      validations.invalidMessage = 'Must be at least 2 characters';
    }

    isValid = specialTextValid && trimmedVal.length >= 2 && trimmedVal.length <= 50 && isValid;
  }

  //do check here
  return isValid;
};

export const checkAlternativeInputValidity = (value, validations) => {
  //for boolean values
  if (typeof value === 'boolean') {
    return value;
  }

  if ((typeof value === 'string') && (value).length === 0) {
    return true;
  }

  //for string values
  let isValid = true;
  const trimmedVal = value && value.trim();
  if (validations?.required) {
    isValid = trimmedVal === '' ? false : true;
  }

  if (validations?.type === 'number') {
    isValid = trimmedVal.match(/^[0-9]+$/) === null ? false : true;
  }

  if (validations?.type === 'email') {
    isValid = validateEmail(trimmedVal);
  }

  if (validations?.type === 'cellphoneNo') {
    isValid = validateCellphonNo(trimmedVal);
  }

  if (validations?.minLength) {
    isValid = trimmedVal.length >= validations.minLength && isValid ? true : false;
  }

  if (validations?.maxLength) {
    isValid = trimmedVal.length <= validations.maxLength && isValid ? true : false;
  }

  if (validations?.isPhoneNumber) {
    isValid = /^\d{10}$/.test(trimmedVal) && isValid ? true : false;
  }

  if (validations?.selectOptions) {
    isValid = trimmedVal !== '--select--';
  }

  return isValid;
};

export const getDrivePackageImageURL = (provider) => {

  if (showProviderLogos)
    return `${CMS_Base_Url}saleslead_${((provider).replace(/ /g, '_').toLowerCase()).slice(0, 20)}.png`;

  return(VodacomLogo)
}

export const isMobileView = () => {
  let check = false;
  // eslint-disable-next-line no-useless-escape
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

export const getHashInteger = value => {
  if (value.length === 0) {
    return 0;
  }
  let hash = 0, i, chr;
  for (i = 0; i < value.length; i++) {
    chr = value.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  if (hash < 0) {
    hash *= -1;
  }
  return hash;
}

const validateEmail = email => {
  // eslint-disable-next-line no-useless-escape
  const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailReg.test(String(email).toLowerCase());
}

const validateCellphonNo = cellphoneNo => {
  const check_number_reg = /(^([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$)|(^((0(\d{9}))|(\+?27(\d{9})))$)/;
  const mobileNumberReg = /((?:\+27)|0|27)(6|7|8)(\d{8})/;
  return (mobileNumberReg.test(String(cellphoneNo).toLocaleLowerCase()) && check_number_reg.test(String(cellphoneNo).toLocaleLowerCase()));
}

const validateWorkNo = WorkNo => {
  const check_number_reg = /(^([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$)|(^((0(\d{13}))|(0(\d{9}))|(\+?27(\d{13}))|(\+?27(\d{9})))$)/i;
  const workNumberReg = /^((?:\+27)|0|27)(?!9)(\d{9})$/i;
  return (workNumberReg.test(String(WorkNo)) && check_number_reg.test(String(WorkNo)));
}

const validateSalesOrderNumber = salesOrderNumber => {
  const salesOrderNumberReg = /(^(so|q)([0-9-a-zA-Z]{13}))/;
  return (salesOrderNumberReg.test(String(salesOrderNumber).toLocaleLowerCase()));
}

const validateIdNumber = idNumber => {
  let validate_id_num = idNumber;

  // assume everything is correct and if it later turns out not to be, just set this to false
  let correct = true;

  // SA ID Number have to be 13 digits, so check the length
  if (validate_id_num.length != 13 || isNaN(validate_id_num)) {
    correct = false;
  }

  // get first 6 digits as a valid date
  let tempDate = new Date(validate_id_num.substring(0, 2), validate_id_num.substring(2, 4) - 1, validate_id_num.substring(4, 6));

  let id_date = tempDate.getDate();
  let id_month = tempDate.getMonth();

  if (!((tempDate.getYear() == validate_id_num.substring(0, 2)) && (id_month == validate_id_num.substring(2, 4) - 1) && (id_date == validate_id_num.substring(4, 6)))) {
    correct = false;
  }

  // apply Luhn formula for check-digits
  let tempTotal = 0;
  let checkSum = 0;
  let multiplier = 1;
  for (let i = 0; i < 13; ++i) {
    tempTotal = parseInt(validate_id_num.charAt(i)) * multiplier;
    if (tempTotal > 9) {
      tempTotal = parseInt(tempTotal.toString().charAt(0)) + parseInt(tempTotal.toString().charAt(1));
    }
    checkSum = checkSum + tempTotal;
    multiplier = (multiplier % 2 == 0) ? 1 : 2;
  }
  if ((checkSum % 10) != 0) {
    correct = false;
  }

  return correct;

}

export const bytesToReadable = (
  bytes,
  decimal = 2
) => {

  if (
    typeof bytes !== 'number' ||
    bytes <= 0
  ) {

    return '0 Bytes';
  }

  const kb = 1024;

  const sizes = [
    'Bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB'
  ];

  const i = Math.floor(Math.log(bytes) / Math.log(kb));

  return `${parseFloat((bytes / Math.pow(kb, i)).toFixed(decimal))} ${sizes[i]}`;
};

export const setVodacomHeaderVisibility = visibility => {
  
  if (process.env?.NODE_ENV === 'development')
    return;

  const cssDisplayProp = visibility ? 'block' : 'none';
  document.querySelector('header').style.display = cssDisplayProp;
}

export const getKeyValueData = (data) => {
  let newData = {};
  for (let key in data) {
    newData = { ...newData, [key]: { label: data[key].name, value: data[key].value } }
  }
  return newData;
}

export const getKeyValueDataFromAddressobj = (data, unitNo, buildingName) => {
  let newData = {};
  const newKeys = {
    streetNumber: {
      key: 'streetNo',
      name: 'Street no.'
    },
    route: {
      key: 'streetName',
      name: 'Street name'
    },
    suburb: {
      key: 'suburb',
      name: 'Suburb'
    },
    postStreet: {
      key: 'postalCode',
      name: 'Postal code'
    },
    town: {
      key: 'town',
      name: 'Town/City'
    },
    province: {
      key: 'province',
      name: 'Province'
    },
    formattedAddress: {
      key: 'searchBar',
      name: 'Search Address'
    },
    streetName: {
      key: 'streetName',
      name: 'Street name'
    },
    postalCode: {
      key: 'postalCode',
      name: 'Postal code'
    },
    city: {
      key: 'town',
      name: 'Town/City'
    }
  }
  for (let key in data) {
    if (key in newKeys) {
      newData = { ...newData, [newKeys[key]?.key]: { label: newKeys[key]?.name, value: data[key] } }
    }
  }
  newData = {
    unitNumber: {
      label: 'Unit no.',
      value: unitNo || ''
    },
    buildingName: {
      label: 'Building name',
      value: buildingName || ''
    },
    ...newData
  }
  return newData;
}

// Create array
export const createArray = (data) => {
  const formCompArray = [];
  for (let key in data) {
    formCompArray.push({
      key: key,
      config: data[key]
    });
  }
  return formCompArray;
}

// Get Address Object
export const getDetailedAddressObject = (address) => {
  let addressObj = null;
  return getAddressObject({ searchText: address })
    .then(response => {
      if (response && response.result) {
        addressObj = response.result;
        return Promise.resolve(addressObj)
      }
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

// Get Full Address
export const getFullAddress = (data) => {
  if (data?.streetNumber) {
    return (`${data?.streetNumber ? data?.streetNumber + ' ' : ''}${data?.route ? data.route + ', ' : ''}${data?.suburb ? data.suburb + ', ' : ''}${data?.town ? data.town + ', ' : ''}${data?.province ? data.province + ', ' : ''}${data?.postStreet ? data.postStreet : ''}`)
  } else {
    return (`${data?.streetNo ? data?.streetNo + ' ' : ''}${data?.streetName ? data.streetName + ', ' : ''}${data?.suburb ? data.suburb + ', ' : ''}${data?.town ? data.town + ', ' : ''}${data?.province ? data.province + ', ' : ''}${data?.postalCode ? data.postalCode : ''}`)
  }
}

export const getProvinceData = () => {
  return getProvinceList()
    .then(response => Promise.resolve(response.result.provinces))
    .catch(error => Promise.reject(error))
}

export const getBanksListData = () => {
  return getBankArray()
    .then(response => Promise.resolve(response.result.BANK_DETAILS))
    .catch(error => Promise.reject(error))
}

export const registerEnterEvent = () => {
  // Move to next filed on Enter
  let inputs = document.querySelectorAll('input,select');
  let nextInput = undefined;
  for (let i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('keypress', function (e) {
      if (e.which == 13) {
        e.preventDefault();
        nextInput = document.querySelectorAll('[tabIndex="' + (this.tabIndex + 1) + '"]');
        if (nextInput.length === 0) {
          nextInput = document.querySelectorAll('[tabIndex="1"]');
        }
        nextInput[0] && nextInput[0].focus();
      }
    })
  }
}

export const filterNumbers = (value) => value?.split(/ /)[0].replace(/[^\d]/g, '');

export const toDate = today => {
  if (!today || typeof today === 'string') return '';
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return dd + '/' + mm + '/' + yyyy;
};

export const toDateObj = date => {
  if (date === '') return;
  var arr = date?.split('/');
  var tempArr = [arr[1], arr[0], arr[2]];
  return (tempArr.join('/'));
}

export const getFileNameWithoutExtension = (filename = '') => {
  // eslint-disable-next-line no-useless-escape
  const splits = filename.match(/([^\/]+)(?=\.\w+$)/);
  return splits.length > 0 ? splits[0] : '';
}

export const validateDate = (day, month, year) => {
  try {
    const dateObj = new Date(year, month - 1, day);
    if (dateObj.toString() === 'Invalid Date')
      return false;
    const dateObjDay = dateObj.getDate();
    const dateObjMonth = dateObj.getMonth() + 1;
    const dateObjYear = dateObj.getFullYear();

    return parseInt(day) === dateObjDay && parseInt(month) === dateObjMonth && parseInt(year) === dateObjYear;
  } catch (error) {
    console.log(error);
  }
  return false;
}

export const validateDateOfBirth = (day, month, year) => {
  try {
    const dateObj = new Date(year, month - 1, day);
    if (dateObj.toString() === 'Invalid Date')
      return false;
    const dateObjDay = dateObj.getDate();
    const dateObjMonth = dateObj.getMonth() + 1;
    const dateObjYear = dateObj.getFullYear();

    const currentDate = new Date();

    if (dateObjYear <= 999 || (currentDate.getFullYear() - dateObjYear) < 18) {
      return false;
    }

    return parseInt(day) === dateObjDay && parseInt(month) === dateObjMonth && parseInt(year) === dateObjYear;
  } catch (error) {
    console.log(error);
  }
  return false;
}

export const getHashCode = (stringValue = '') => {
  let hash = 0, chr;
  if (stringValue.length === 0) return hash;
  for (let counter = 0; counter < stringValue.length; counter++) {
    chr = stringValue.charCodeAt(counter);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
};

export const getPageArray = (packagesArray) => {
  let totalRequiredPages = Math.ceil(packagesArray[0]?.length / 12);
  let pageArray = [];
  for (let i = 1; i <= totalRequiredPages; i++) {
    pageArray.push(i);
  }
  return pageArray;
}

export const getSelectedProductsArrays = (selectedPackage, selectedAdditionalServices, additionalServices) => {

  const taggingIdArray = [selectedPackage.provider + ' - ' + selectedPackage.description];
  const taggingQtyArray = [1];
  const taggingPriceArray = [selectedPackage.productPrice.value];
  // Need to move this tagging call

  for (let key in selectedAdditionalServices) {
    if (selectedAdditionalServices[key]) {
      const service = additionalServices.serviceCategories ?
        additionalServices.serviceCategories.find(e => e.vasCategory === key) :
        additionalServices.find(e => e.serviceKey === key);

      let price = service.priceDescription;

      taggingIdArray.push(service.acronym);
      taggingQtyArray.push(1);
      taggingPriceArray.push(price);
    }
  }

  return ({
    taggingIdArray,
    taggingQtyArray,
    taggingPriceArray
  })
}

export const whatsappUs = (e) => {
  e.preventDefault();
  window.open('https://api.whatsapp.com/send/?phone=27826223509', '_blank');
};

export const setTrackingIds = () => {

  const utagData = window.utag?.data;

  const sessionTrackingIds = JSON.parse(sessionStorage.getItem('trackingIds'));

  const trackingIds = {
    gclid: utagData?.['qp.gclid'] || sessionTrackingIds?.gclid || '',
    fbclid: utagData?.['qp.fbclid'] || sessionTrackingIds?.fbclid || '',
    cid: utagData?.['qp.cid'] || sessionTrackingIds?.cid || '',
  }

  sessionStorage.setItem(SessionsKeys.TrackingIds, JSON.stringify(trackingIds));
}

export const getTrackingIds = () => {

  const trackingIds = JSON.parse(sessionStorage.getItem('trackingIds'));

  if (!trackingIds) {

    return {};
  }

  return {
    googleClickIndicator: trackingIds.gclid || '',
    facebookClickIndicator: trackingIds.fbclid || '',
    campaignIndicator: trackingIds.cid || '',
  };
}

export const transformTopPicks = (topPicksObj) => {

  if (!topPicksObj || Object.keys(topPicksObj).length === 0) {
    return [];
  }

  const topPicks = Object.entries(topPicksObj)
    .filter(([ _, value ]) => value && Object.keys(value).length > 0)
    .map(([ key, value ]) => ({
      cardKey: key,
      ...value
    }));

  return topPicks.length > 0 ? topPicks : [];
};

export const capitalizeFirstChar = (str) => {
  if (!str) {
    return '';
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getUniqueSpeedsArray = (data) => {

  return data.map(item => [ item.download, item.upload ]);
};

export const normaliseContractTerm = (term) => {

  if (!term){
    return null;
  }

  const cleaned = term.replace(/months/i, '').trim();

  return cleaned.toLowerCase() === 'month to month' ? '1' : cleaned;
};
